// extracted by mini-css-extract-plugin
export default {"Root":"Skeleton_Root__WjTIL","Rectangular":"Skeleton_Rectangular__BUOm+"};